import axios from 'axios';

const savePeacockOrder = async ({
  businessName,
  numberOfLocations,
  industry,
  businessEmail,
  businessEmailConfirmation,
  firstName,
  lastName,
  role,
  businessAddress,
  businessAddress2,
  city,
  state,
  zipCode,
  phone,
  socialByUpShow,
  socialHandle,
  noSocial,
  mediaAccount,
  businessOutsideUS,
  numberOfDevices,
  shippingATTN,
  shippingBusinessAddress,
  shippingBusinessAddress2,
  shippingCity,
  shippingState,
  shippingZipCode,
  billingAddress,
  billingAddress2,
  billingCity,
  billingState,
  billingZipCode,
  useBusinessAddressForBilling,
  useBusinessAddressForShipping,
  agree,
  paymentMethod,
  activationCharge,
  subscriptionCharge,
  shippingCharge,
  chargesSubscriptionCharge,
  chargesActivationCharge,
  chargesShippingCharge,
  processing,
  source,
  packageId,
  fireCode,
  billingPlan,
  shipping,
}) => {
  try {
    const body = {
      businessName,
      numberOfLocations,
      industry,
      businessEmail,
      businessEmailConfirmation,
      firstName,
      lastName,
      role,
      businessAddress,
      businessAddress2,
      city,
      state,
      zipCode,
      phone,
      socialByUpShow,
      socialHandle,
      noSocial,
      mediaAccount,
      businessOutsideUS,
      numberOfDevices,
      shippingBusinessAddress,
      shippingBusinessAddress2,
      shippingATTN,
      shippingCity,
      shippingState,
      shippingZipCode,
      billingAddress,
      billingAddress2,
      billingCity,
      billingState,
      billingZipCode,
      useBusinessAddressForBilling,
      useBusinessAddressForShipping,
      agree,
      paymentMethod,
      activationCharge,
      subscriptionCharge,
      shippingCharge,
      charges: {
        subscription_charge: chargesSubscriptionCharge,
        activation_charge: chargesActivationCharge,
        shipping_charge: chargesShippingCharge,
      },
      processing,
      source,
      packageOption: packageId,
      fireCode,
      billingPlan,
      shippingOption: shipping,
    };

    const response = await axios.post(`${process.env.REACT_APP_BILLING_BASE_URL}selfserve/account/provision-peacock`, body);
    if (response.status === 200) {
      return response.data;
    }

    console.error('Unable to save order. Response Status Text', response.statusText);
    console.error('Unable to save order. Response Status Code', response.status);
    console.error('Unable to save order. Response Data ', response.data);
    return false;
  } catch (error) {
    console.error('Unable to save order. ', error);
    return false;
  }
};
export default savePeacockOrder;
